module.exports = __webpack_public_path__ + "static/media/image_black.ec0559ba.png";